import Http from '@/api/http.js'

export default {

  index(filter) {
    return Http.get('/pixes', {params: {...filter}})
  },
  indexByParams(filter) {
    return Http.get('/pixes/by_params', {params: {...filter}})
  },

  indexByModel(model, model_id) {
    return Http.get(`/${model}/${model_id}/pixes`)
  },

  create(pix){ 
    return Http.post(`/pixes`, {pix: {...pix}})
  },

  createPixCobranca(pix){
    return Http.post(`/pixes/create_pix_cobranca`, {pix: {...pix}})
  },

  refund(pix){
    return Http.post(`/pixes/${pix.id}/refund`, {pix: {...pix}})
  },

  update(pix){
    return Http.put(`/pixes/${pix.id}`, {pix: {...pix}})
  },

  show(id, details) {
    return Http.get(`/pixes/${id}`, { params: {...details}});
  },

  delete(id){
    return Http.delete(`/pixes/${id}`)
  },

  verify(id){
    return Http.get(`/pixes/${id}/verify`)
  },

  cancel(id){
    return Http.get(`/pixes/${id}/cancel`)
  },
}
